const getResultRange = (offset: number, totalHits: number, itemsPerPage: number): string =>
    offset + itemsPerPage > totalHits ? `${offset + 1}-${totalHits}` : `${offset + 1}-${offset + itemsPerPage}`;

export default getResultRange;
